module.exports = __webpack_public_path__ + "assets/img/887832fb29c938e1304b2eb545aa34e7.png";